import { useConflictCard } from "../gantt-carga/hooks/use-conflict-card";
import type { ConflictBadgeProps, ConflictBadgeViewModel } from "./types-conflict-badge";

export function useConflictBadge({
  label,
  groups,
  tooltip,
  onMouseEnter,
  onMouseLeave,
}: ConflictBadgeProps): ConflictBadgeViewModel {
  const { anchorProps, card } = useConflictCard();
  const comCard = Boolean(groups && groups.length > 0);

  return {
    label,
    groups: groups ?? [],
    comCard,
    tooltip,
    anchorProps: comCard ? anchorProps : { tabIndex: 0, onMouseEnter, onMouseLeave },
    card,
  };
}
